import ScrollTrackerAnchor from "./scroll_tracker_anchor";

export default class ScrollTracker 
{
  public static SELECTOR = '.scroll-tracker';
  public static OFFSET: number = 15;
  public static COOLDOWN: number = 100;
  private readonly scrollHandler: EventListener;
  private readonly scrollEndHandler: EventListener;

  public readonly wrapper: HTMLElement;
  private readonly anchors: ScrollTrackerAnchor[] = [];

  cooldown: number|NodeJS.Timeout|undefined;
  isActive: boolean = true;
  currentSideScrollTarget: ScrollTrackerAnchor|null = null;

  constructor(wrapper: HTMLElement)
  {
    this.wrapper = wrapper;

    this.scrollHandler = this.handleScrollEvent.bind(this);
    this.scrollEndHandler = this.handleScrollEndEvent.bind(this);

    const anchorElements = this.wrapper.querySelectorAll('a[href^="#"]') as NodeListOf<HTMLAnchorElement>;

    anchorElements.forEach((anchor) => {
      this.anchors.push(new ScrollTrackerAnchor(anchor, this));
    });
    this.enable();
  }

  enable(): void
  {
    //DO NOT BUBBLE SCROLL!
    document.addEventListener('scroll', this.scrollHandler, false);
    document.addEventListener('scrollend', this.scrollEndHandler, true);
    this.findSection();
  }

  handleScrollEvent(event: MouseEvent): void
  {
    clearTimeout(this.cooldown);
    this.findSection();
    this.cooldown = setTimeout( () => {
      this.setActive(true);
    }, ScrollTracker.COOLDOWN );
  }

  handleScrollEndEvent(event: Event): void
  {
    if(event.target == this.wrapper) {
      this.currentSideScrollTarget = null
    }
  }

  setActive(active: boolean)
  {
    this.isActive = active;
    if(active) {
      this.findSection();
    } else {
      this.anchors.forEach((anchor) => anchor.setActive(false));
    }
  }

  findSection()
  {
    if (!this.isActive) return

    let lastActiveAnchor: ScrollTrackerAnchor|null = null;
    this.anchors.forEach((anchor) => {
      const isActive = anchor.toggleActive();
      if(isActive) {
        lastActiveAnchor = anchor;
      }
    });
    lastActiveAnchor!.scrollIntoView();
  }

  isHorizontal(): boolean
  {
    const wrapperStyle = getComputedStyle(this.wrapper);
    return (wrapperStyle.getPropertyValue('overflow-x') == 'scroll');
  }
}